<template>
	<div class="product-cross-promo__component">
		<p class="u-txt-sm">
			<span class="h h-sm u-mrg-right-qtr" v-html="productType"></span>
			{{ totalItems }} Products
		</p>
		<div class="fx-grid">
			<product-cross-promo-item
				v-for="(product, index) in filteredItems"
				:key="index"
				:item="product"
			></product-cross-promo-item>
		</div>		
	</div>
</template>

<script>
import axios from "axios";
import ProductCrossPromoItem from "./ProductCrossPromoItem.vue";
export default {
	components: { ProductCrossPromoItem },
	props: {},
	data() {
		return {
			products: [],
			selectedItem: null,
			currentPage: 1,
			totalItems: null,
			totalShowing: 4,
			subheadline: "",			
			productType: "",
			increment: 4,
			data: [],
		};
	},
	created() {
		//or can pull path from a prop passed into the component
	},
	mounted() {
		this.setGallery(this.$props.productList[0]);
		this.getGalleryContent();
		this.productInfo(this.$props.productList[1][0]);
	},
	props: {
		dataUrl: String,
		productList: Array,
	},
	methods: {
		setGallery(response) {
			this.products = response;
			this.totalItems = parseInt(response.length);
			this.getGalleryContent();
		},
		productInfo(response) {			
			this.productType = response.productType;
		},
		getGalleryContent() {
			this.loading = true;
		},
		loadMore() {
			if (this.totalShowing >= this.totalItems) return;
			this.totalShowing =
				this.totalShowing + this.increment >= this.totalItems
					? this.totalItems
					: this.totalShowing + this.increment;
		},
		viewAll() {
			this.totalShowing = this.totalItems;
		},
	},
	computed: {
		filteredItems() {
			return this.products.slice(0, this.totalShowing).map((item) => {
				return item;
			});
		},
	},
};
</script>
